import { AlertCircle as FiAlertCircle } from 'components/icons'
export const DisabledProtection = () => {
	return (
		<div className="flex flex-col items-center justify-center my-6">
			<FiAlertCircle className="h-7 w-7 text-t-base-blue" />
			<strong className="text-color-text-default text-lg my-2 font-medium">
				AI protection disabled
			</strong>
			<span className="text-t-checkbox-unactive max-w-[360px] text-center">
				Without automated protection you are leaving your campaigns to high risk
				of click fraud.
			</span>
		</div>
	)
}
